import { cn } from "@/lib/utils";
import { SrIcon } from "@/components/ui/SrIcon";
import { UnreadBadge } from "@/components/shared/UnreadBadge";

interface ProjectUpdatesButtonProps {
  /** Tilgjengelig navn, «Prosjektoppdateringer». */
  ariaLabel: string;
  /** Antall uleste oppdateringer. 0/undefined = ingen badge. */
  unreadCount?: number;
  onClick: () => void;
  className?: string;
}

/**
 * VIB-2179: ikonknappen i prosjektoversikten som åpner prosjektoppdateringene,
 * med ulest-badge. stopPropagation så radklikk (naviger til prosjekt) ikke
 * utløses.
 */
export function ProjectUpdatesButton({ ariaLabel, unreadCount = 0, onClick, className }: ProjectUpdatesButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={cn(
        "relative inline-flex items-center justify-center w-10 h-10 shrink-0 text-muted-foreground hover:text-foreground",
        unreadCount > 0 && "text-foreground",
        className,
      )}
    >
      <SrIcon name="message-square" className="w-4 h-4" />
      <UnreadBadge count={unreadCount} className="top-1 right-1" />
    </button>
  );
}

export default ProjectUpdatesButton;
